
import { notificationsMixin } from '../../mixins'

export default {
  mixins: [notificationsMixin],
  props: {
    playlists: {
      default: () => [],
      type: Array,
    },
    title: {
      default: null,
      type: String,
    },
    notificationsTag: {
      type: String,
      default: null,
    },
  },
  computed: {
    isSubscribed () {
      if (!this.notificationsTag) return false
      return this.notificationSubscriptions.includes(this.notificationsTag)
    },
  },
}
